import * as React from 'react';
import {Link} from 'react-router';

declare const require: any;
const $: any = require('jquery');

export class Registration extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            sent: false
        }
    }
    
    private register(e) {
        e.preventDefault();
        $.post('/loudhead/2016/reg', $(e.target).serialize(), (data) => {
            if (data) {
                this.setState({sent: true, ticket: data.ticket});
            } else {
                alert('Что-то пошло не так. Проверьте правильность заполнения формы и попробуйте еще раз.');
            }
        }, 'json').error(function () {
            alert('Что-то пошло не так. Попробуйте еще раз.');
        });
    }
    
    render() {
        return (
            <section className="sony-form">
                <div className="inner">
                    <div className="sent">
                        <h1>Регистрация на VIP-стенд Sony закрыта</h1>
                        <p>Вы можете зарегистрироваться на выставке LOUDHEAD и посетить стенд Sony в течение всех дней работы выставки в обычном режиме.</p>
                    </div>
                </div>
                {/*<div className="inner">
                    {this.state.sent ?
                        <div className="sent">
                            <h1>Вы успешно зарегистрированы!</h1>
                            <p>На ваш адрес электронной почты отправлено приглашение на выставку.</p>
                        </div>
                        :
                        <div>
                            <h1>Хочешь первым послушать все новинки SONY и пообщаться со специальными гостями мероприятия? Зарегистрируйся сейчас и получи VIP приглашение в зону SONY!</h1>
                            <h2>VIP ПРИГЛАШЕНИЕ НА СТЕНД SONY</h2>
                            <hr />
                            <form onSubmit={e => this.register(e)}>
                                <input type="hidden" name="type" value="sony"/>
                                <div><label>Фамилия*</label><input required name="lastName"/></div>
                                <div><label>Имя*</label><input required name="name"/></div>
                                <div><label>Номер телефона*</label><input required type="tel" name="phone"/></div>
                                <div><label>Электронная почта*</label><input required type="email" name="email"/></div>
                                <small>* Поля обязательные для заполнения</small>
                                <div className="btn">
                                    <button type="submit">
                                        Зарегистрироваться
                                    </button>
                                </div>
                            </form>
                        </div>
                    }
                </div>
                <div className="desc">
                    *После регистрации вы получите на адрес электронной почты приглашение с правом посещения семинара со специальным гостем от компании SONY.
                </div>*/}
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Sony/Registration.tsx
 **/